import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import * as httpMethods from '../index';
export var axiosBaseQuery = function axiosBaseQuery() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var url, _ref$method, method, _ref$body, body, result, _err$response, _err$response2, err;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _ref.url, _ref$method = _ref.method, method = _ref$method === void 0 ? 'get' : _ref$method, _ref$body = _ref.body, body = _ref$body === void 0 ? {} : _ref$body;
              _context.prev = 1;
              _context.next = 4;
              return httpMethods[method](url, body);

            case 4:
              result = _context.sent;
              return _context.abrupt("return", {
                data: result
              });

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              err = _context.t0;
              return _context.abrupt("return", {
                error: {
                  status: (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status,
                  data: (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data
                }
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};